import { render, staticRenderFns } from "./PopupEditRoles.vue?vue&type=template&id=72327ece&scoped=true&"
import script from "./PopupEditRoles.vue?vue&type=script&lang=js&"
export * from "./PopupEditRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72327ece",
  null
  
)

export default component.exports